<div class="scheduler-header-holder">
  @switch (s.selectedPeriod().period) {

  @case ('day') {
  <div class="large-period-holder" [ngClass]="s.selectedPeriod().period">
    <!--<div class="period-large-box">{{s.weekDayNames()[s.selectedDate().weekday - 1]}}</div>-->
    <div class="period-large-box">{{s.selectedDate().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}}</div>
  </div>

  <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period" #scrollableDiv>
    @for (period of s.rangesInPeriod(); track $index){
    <div class="period-small-box">{{period.toFormat('h:mm a')}}</div>
    }
  </div>
  }

  @case ('workDay') {
  <div class="large-period-holder" [ngClass]="s.selectedPeriod().period">
    <!--<div class="period-large-box">{{s.weekDayNames()[s.selectedDate().weekday - 1]}}</div>-->
    <div class="period-large-box">{{s.selectedDate().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}}</div>
  </div>

  <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period" #scrollableDiv>
    @for (period of s.rangesInPeriod(); track $index){
    <div class="period-small-box">{{period.toFormat('h:mm a')}}</div>
    }
  </div>
  }

  @case ('week') {
  <div class="large-period-holder" [ngClass]="s.selectedPeriod().period">
    <!--<div class="period-large-box">{{s.firstSegmentOfActivePeriod().monthLong}}</div>-->
    <div class="period-large-box">{{s.rangesInPeriod()[0].toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}} - {{s.rangesInPeriod()[s.rangesInPeriod().length - 1].toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}}</div>
  </div>

  <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period">
    @for (period of s.rangesInPeriod(); track $index){
    <div class="period-small-box">{{s.weekDayNames()[period.weekday - 1]}}</div>
    }
  </div>
  }

  @case ('2week'){
  <div class="large-period-holder" [ngClass]="s.selectedPeriod().period">
    <!--<div class="period-large-box">{{s.firstSegmentOfActivePeriod().monthLong}}</div>-->
    <div class="period-large-box">{{s.rangesInPeriod()[0].toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}} - {{s.rangesInPeriod()[s.rangesInPeriod().length - 1].toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}}</div>
  </div>

  <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period">
    @for (period of s.rangesInPeriod(); track $index){
    <div class="period-small-box">{{s.weekDayNames()[period.weekday - 1]}}</div>
    }
  </div>
  }

  @case ('month'){
  <div class="large-period-holder" [ngClass]="s.selectedPeriod().period">
    <!--<div class="period-large-box">{{s.firstSegmentOfActivePeriod().monthLong}}</div>-->
    <div class="period-large-box">{{s.rangesInPeriod()[0].toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}} - {{s.rangesInPeriod()[s.rangesInPeriod().length - 1].toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })}}</div>
  </div>

  <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period">
    @for (period of s.rangesInPeriod(); track $index){
    <div class="period-small-box">{{period.day}}</div>
    }
  </div>
  }

  @case ('year'){
  <div class="large-period-holder" [ngClass]="s.selectedPeriod().period">
    <!--<div class="period-large-box">{{s.firstSegmentOfActivePeriod().year}}</div>-->
    <div class="period-large-box">{{s.rangesInPeriod()[0].toLocaleString({month: 'short', day: '2-digit' })}} - {{s.rangesInPeriod()[s.rangesInPeriod().length - 1].toLocaleString({ month: 'short', day: '2-digit' })}}</div>
  </div>

  <div class="mixed-period-holder scroller" #scrollableDiv>
    <div class="mid-period-holder" [ngClass]="s.selectedPeriod().period">
      @for (period of s.midRangesInPeriod(); track $index){
      @if (period && period.daysInMonth){
      <div class="period-mid-box" [ngStyle]="{ 'min-width': (period.daysInMonth * 40) + 'px' }">{{period.monthLong}}</div>
      }
      }
    </div>

    <div class="small-period-holder" [ngClass]="s.selectedPeriod().period">
      @for (period of s.rangesInPeriod(); track $index){
      <!--<div class="period-small-box">{{period.startOf(s.selectedPeriod().smallPeriod).month}}/{{period.startOf(s.selectedPeriod().smallPeriod).day}} - {{period.endOf(s.selectedPeriod().smallPeriod).month}}/{{period.endOf(s.selectedPeriod().smallPeriod).day}}</div>-->
      <div class="period-small-box">{{period.day}}</div>
      }
    </div>
  </div>
  }

  @default {
  Default case.
  }
  }
</div>